module.exports = __webpack_public_path__ + "img/logo.0323388a.png";